import React from "react";
import { cn } from "@/lib/utils";
import { FormInput } from "./form-input";
import { COLORS } from "../../constants/colors";

interface FormColorSelectorProps {
  value?: string;
  onChange?: (color: string) => void;
  defaultColor?: string;
  className?: string;
  isInvalid?: boolean;
  onFocus?: () => void;
}

const FormColorSelector: React.FC<FormColorSelectorProps> = ({
  value,
  onChange,
  defaultColor = COLORS.FORM_DEFAULT_COLOR,
  className,
  isInvalid = false,
  onFocus,
}) => {
  const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  const handleFocus = () => {
    onFocus?.();
  };

  const colorValue = value || defaultColor;

  return (
    <div className={cn("flex gap-2", className)}>
      <div className="relative h-8 w-16">
        <input
          type="color"
          value={colorValue}
          onChange={handleColorChange}
          onFocus={handleFocus}
          className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
        />
        <div
          className={cn(
            "h-full w-full rounded-md border focus:border-secondary focus:outline-none focus:ring-2 focus:ring-secondary",
            isInvalid
              ? "border-red-500 focus:border-red-500 focus:ring-red-500"
              : "border-edge"
          )}
          style={{ backgroundColor: colorValue }}
        />
      </div>
      <FormInput
        type="text"
        value={colorValue}
        onChange={handleTextChange}
        onFocus={handleFocus}
        className={cn(
          "w-full bg-white",
          isInvalid
            ? "border-red-500 focus:border-red-500 focus:ring-red-500"
            : ""
        )}
      />
    </div>
  );
};
FormColorSelector.displayName = "FormColorSelector";

export { FormColorSelector };
export type { FormColorSelectorProps };
